import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
import { DEFAULT_CLIENT_MAX_RETRY_INTERVAL, DEFAULT_CLIENT_MIN_RETRY_INTERVAL, DEFAULT_CLIENT_RETRY_COUNT, DEFAULT_CLIENT_RETRY_INTERVAL, isNumber, shouldRetry, updateRetryData } from "../util/exponentialBackoffStrategy";
import { delay } from "../util/delay";
/**
 * A policy that retries when there's a system error, identified by the codes "ETIMEDOUT", "ESOCKETTIMEDOUT", "ECONNREFUSED", "ECONNRESET" or "ENOENT".
 * @param retryCount - Maximum number of retries.
 * @param retryInterval - The client retry interval, in milliseconds.
 * @param minRetryInterval - The minimum retry interval, in milliseconds.
 * @param maxRetryInterval - The maximum retry interval, in milliseconds.
 * @returns An instance of the {@link SystemErrorRetryPolicy}
 */

export function systemErrorRetryPolicy(retryCount, retryInterval, minRetryInterval, maxRetryInterval) {
  return {
    create: function create(nextPolicy, options) {
      return new SystemErrorRetryPolicy(nextPolicy, options, retryCount, retryInterval, minRetryInterval, maxRetryInterval);
    }
  };
}
/**
 * A policy that retries when there's a system error, identified by the codes "ETIMEDOUT", "ESOCKETTIMEDOUT", "ECONNREFUSED", "ECONNRESET" or "ENOENT".
 * @param retryCount - The client retry count.
 * @param retryInterval - The client retry interval, in milliseconds.
 * @param minRetryInterval - The minimum retry interval, in milliseconds.
 * @param maxRetryInterval - The maximum retry interval, in milliseconds.
 */

export var SystemErrorRetryPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(SystemErrorRetryPolicy, _BaseRequestPolicy);

  var _super = _createSuper(SystemErrorRetryPolicy);

  function SystemErrorRetryPolicy(nextPolicy, options, retryCount, retryInterval, minRetryInterval, maxRetryInterval) {
    var _this;

    _classCallCheck(this, SystemErrorRetryPolicy);

    _this = _super.call(this, nextPolicy, options);
    _this.retryCount = isNumber(retryCount) ? retryCount : DEFAULT_CLIENT_RETRY_COUNT;
    _this.retryInterval = isNumber(retryInterval) ? retryInterval : DEFAULT_CLIENT_RETRY_INTERVAL;
    _this.minRetryInterval = isNumber(minRetryInterval) ? minRetryInterval : DEFAULT_CLIENT_MIN_RETRY_INTERVAL;
    _this.maxRetryInterval = isNumber(maxRetryInterval) ? maxRetryInterval : DEFAULT_CLIENT_MAX_RETRY_INTERVAL;
    return _this;
  }

  _createClass(SystemErrorRetryPolicy, [{
    key: "sendRequest",
    value: function sendRequest(request) {
      var _this2 = this;

      return this._nextPolicy.sendRequest(request.clone()).catch(function (error) {
        return retry(_this2, request, error.response, error);
      });
    }
  }]);

  return SystemErrorRetryPolicy;
}(BaseRequestPolicy);

function retry(_x, _x2, _x3, _x4, _x5) {
  return _retry.apply(this, arguments);
}

function _retry() {
  _retry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(policy, request, operationResponse, err, retryData) {
    var shouldPolicyRetry;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            shouldPolicyRetry = function _shouldPolicyRetry(_response, error) {
              if (error && error.code && (error.code === "ETIMEDOUT" || error.code === "ESOCKETTIMEDOUT" || error.code === "ECONNREFUSED" || error.code === "ECONNRESET" || error.code === "ENOENT")) {
                return true;
              }

              return false;
            };

            retryData = updateRetryData(policy, retryData, err);

            if (!shouldRetry(policy.retryCount, shouldPolicyRetry, retryData, operationResponse, err)) {
              _context.next = 14;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return delay(retryData.retryInterval);

          case 6:
            return _context.abrupt("return", policy._nextPolicy.sendRequest(request.clone()));

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", retry(policy, request, operationResponse, _context.t0, retryData));

          case 12:
            _context.next = 17;
            break;

          case 14:
            if (!err) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", Promise.reject(retryData.error));

          case 16:
            return _context.abrupt("return", operationResponse);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
  return _retry.apply(this, arguments);
}